"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var PageContainer = function PageContainer(_ref) {
  var classes = _ref.classes,
      children = _ref.children,
      title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.pageWrapper
  }, title && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.headerContainer
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    component: "h1",
    variant: "h4"
  }, title), /*#__PURE__*/_react["default"].createElement(_core.Divider, {
    className: classes.headerDivider
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.contentContainer
  }, /*#__PURE__*/_react["default"].createElement("div", null, children)));
};

PageContainer.propTypes = {
  classes: _propTypes["default"].object,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired
};
PageContainer.defaultProps = {
  classes: {}
};

var _default = (0, _withStyles["default"])(_styles["default"])(PageContainer);

exports["default"] = _default;